import axios from "axios";

const API_URL =
  //"https://localhost:44389/api/Verification";
  "https://api.esgo.co.uk/api/Verification";

export const startLiveness = (token) => {
  return axios.post(
    `${API_URL}/start-liveness/${token}`
  );
};

export const processVerification = (token) => {
  return axios.post(
    `${API_URL}/process/${token}`
  );
};